module.exports = __webpack_public_path__ + "static/img/1056.838f55b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1056.jpg
// module id = 238
// module chunks = 0